const PhoneNumber = () => {
  return <div className='contact-phone-number'>+82 10-2455-3704</div>;
};

export default PhoneNumber;
